/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import BelegdruckAktion, { BelegdruckAktionen } from "../Views/BelegdruckView/BelegdruckAktion";

export interface BelegeUrlKontextIds {
    seminarId?: string,
    teilnahmeId?: string,
    bestellterArtikelId?: string,
    seminarreiheId?: string,
    belegungId?: string,
}

export default class BelegeUrlsBuilder {
    public static getBelegBelegpositionenUrl(belegId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/belegpositionen`;
    }

    public static getBelegEmpfaengeradresseUrl(belegId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/adresse`;
    }

    public static getBelegTexteUrl(belegId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/texte`;
    }

    public static getBelegpositionUrl(belegId: string, belegpositionId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/belegposition/${belegpositionId}`;
    }

    public static getZahlungenUrl(belegId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/zahlungen`;
    }

    public static getBelegBelegdruckUrl(belegId: string, blobId: string, ids: BelegeUrlKontextIds, modus: BelegdruckAktion = BelegdruckAktionen.vorschau) {
        return `${BelegeUrlsBuilder.getBelegUrl(belegId, ids)}/belegdruck/${blobId}/${modus}`;
    }

    public static getBelegdruckUrl(blobId: string, ids: BelegeUrlKontextIds, modus: BelegdruckAktion = BelegdruckAktionen.vorschau) {
        return `${BelegeUrlsBuilder.getPrefix(ids)}/belegdruck/${blobId}/${modus}`;
    }

    public static getBelegeUrl(ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getPrefix(ids)}/belege`;
    }

    public static getBelegUrl(belegId: string, ids: BelegeUrlKontextIds) {
        return `${BelegeUrlsBuilder.getPrefix(ids)}/beleg/${belegId}`;
    }

    private static getPrefix(ids: BelegeUrlKontextIds) {
        let url = "";
        if (!!ids.seminarId && !!ids.teilnahmeId) {
            url += `/seminar/${ids.seminarId}/teilnahme/${ids.teilnahmeId}`;
        } else if (!!ids.seminarId) {
            url += `/seminar/${ids.seminarId}`;
        } else if (!!ids.teilnahmeId) {
            url += `/teilnahme/${ids.teilnahmeId}`;
        } else if (!!ids.seminarreiheId) {
            url += `/seminarreihe/${ids.seminarreiheId}`;
        } else if (!!ids.belegungId) {
            url += `/belegung/${ids.belegungId}`;
        }

        if (ids.bestellterArtikelId != null) {
            url += `/bestellterArtikel/${ids.bestellterArtikelId}`
        }

        return url;
    }
}